import './BubbleLoader.css';

export default function BubbleLoader({ size = 0.6, color = 'var(--pink)' }) {
  return (
    <span
      className="customer-portal-bubble-loader"
      style={{
        '--color-1': color,
        '--size': `${size}px`,
        fontSize: `calc(7 * ${size}px)`,
      }}
    />
  );
}
